import { Injectable } from '@angular/core';
import { User, UserToken } from 'types/User';

@Injectable({
  providedIn: 'root'
})
export class SessionService {
  private userId: string | null = null;
  private tagId: string | null = null;
  private walletId: string | null = null;
  private loggedUser: User | null = null;

  setUserId(userId: string): void {
    this.userId = userId;
  }
  getUserId(): string | null {
    return this.userId;
  }
  clearUserId(): void {
    this.userId = null;
  }

  setQRCodeUser(user: UserToken): void {
    sessionStorage.setItem('qr_session_user', JSON.stringify(user));
  }

  getQRCodeUser(): UserToken | null {
    const serializedUser = sessionStorage.getItem('qr_session_user');
    return serializedUser ? JSON.parse(serializedUser) as UserToken : null;
  }

  clearQRCodeUser(): void {
    sessionStorage.removeItem('qr_session_user');
  }

  setTagId(tagId: string): void {
    this.tagId = tagId;
  }
  getTagId(): string | null {
    return this.tagId;
  }
  clearTagId(): void {
    this.tagId = null;
  }

  setWalletId(walletId: string): void {
    this.walletId = walletId;
  }
  getWalletId(): string | null {
    return this.walletId;
  }
  clearWalletId(): void {
    this.walletId = null;
  }

  setLoggedUser(user: User): void {
    this.loggedUser = user;
  }
  getLoggedUser(): User | null {
    return this.loggedUser;
  }
  clearLoggedUser(): void {
    this.loggedUser = null;
  }
}
